import { useReward } from "api/rewards";
import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { memo, useState } from "react";
import { ListResponse } from "types/listing";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
}
export const RewardCategories = memo(({ index, size, onChange }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const isInlineType = size === "inline";
  const [categorySearch, setCategorySearch] = useState("");
  const { useRewardCategoriesList } = useReward();
  const { data: rewardCategories } = useRewardCategoriesList(
    categorySearch
      ? {
          filters: [
            {
              condition: "like",
              query: "name",
              value: categorySearch,
            },
          ],
        }
      : {
          filters: [],
        },
  ) as { data: ListResponse };

  const rewardCategoriesLabels =
    rewardCategories?.items?.map(
      ({
        name,
        rewardCategoryId,
      }: {
        name: string;
        rewardCategoryId: string;
      }) => ({
        label: name || rewardCategoryId,
        id: rewardCategoryId,
      }),
    ) || [];

  return (
    <SelectInput
      name={`filters.${index}.value`}
      displaySearch
      multiple
      data-test-id="filter-value"
      width="100%"
      items={rewardCategoriesLabels}
      size={isInlineType ? "small" : size}
      onChange={onChange}
      asyncSearch={(searchedQuery) => setCategorySearch(searchedQuery)}
      placeholder={message({ id: "value" })}
      adjustWidthToValue={isInlineType}
      className={isInlineType ? classes.inlineValue : ""}
      keepDetailedValue
      validateOnChange
    />
  );
});
